import React, { Component } from 'react'
import { useHistory } from 'react-router-dom'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import AlertModal from '../CommonControlls/AlertModal'
import jsPDF from 'jspdf'
import DropDown from '../CommonControlls/DropdownRendrer'
import DatePicker from 'react-datepicker'
import MapComponent from './GoogleMap'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    MapReducer: (data) => {
      dispatch({ type: 'UpdateData', payload: data })
    },
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class HeatMap_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Save: true,
      Update: true,
      Delete: true,
      View: true,

      Tehsillist: [],
      Provincelist: [],
      Districtlist: [],

      DistrictId: [],

      endDate: new Date(),
      startDate: new Date(),
      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },
    }
  }

  HandleDateChange = (Field, date) => {
    this.setState(
      {
        [Field]: date === '' || date == null ? new Date() : date,
        // isSaveSearch: this.state.isSearchChanged ? true : false
      },
      () => {
        if (
          Field === 'startDate' &&
          this.state.startDate > this.state.endDate
        ) {
          this.setState({ endDate: this.state.startDate })
        }
      },
    )
  }
  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({
      DistrictId: value,
    })
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          <Link to={`/Dispute_Edit/${row.id}`}>
            <button data-toggle="tooltip" title="Edit" class="btn TableRow_btn">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
          </Link>
          <button
            data-toggle="tooltip"
            onClick={() => this.onDelete(row.id)}
            title="Delete"
            class="btn TableRow_btn"
          >
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </button>
        </div>
      )
    }

    const columns = [
      // {
      //     dataField: 'id',
      //     text: 'ID',
      //     sort: true,
      // },
      {
        dataField: 'name',
        text: 'District Name',
      },
      {
        dataField: 'samplesCreated',
        text: 'Samples Created',
      },
      {
        dataField: 'samplesTransported',
        text: 'Samples Transported',
      },
      {
        dataField: 'completedAssignments',
        text: 'Completed Assignments',
        sort: true,
      },
      {
        dataField: 'lat',
        text: 'Latitude',
      },
      {
        dataField: 'lng',
        text: 'Longitude',
      },
      //
      // {
      //     dataField: '',
      //     text: 'Actions',
      //     headerStyle: (colum, colIndex) => { return { width: '120px' } },
      //     formatter: (cell, row) => { return CellMenu(cell, row) },
      //     csvExport: false
      // }
    ]

    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          {/* <Topmenu/>               */}
          <Topmenu
            PageTitle="Heat Map"
            isShowAddBtn={false}
            AddBtnLabel="View Map"
            AddBtnLink="/Map"
          />

          <div class="content">
            <div class="PageHeader_Container">
              <h2 class="Pageheading">Heat Map</h2>
            </div>

            <div class="card">
              <div class="card-body">
                <div className="Table_Search row">
                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">District</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="DistrictId"
                      options={this.state.Districtlist}
                      val={this.state.DistrictId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.DistrictLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">From</label>
                    <DatePicker
                      selected={this.state.startDate}
                      onChange={(date) => {
                        this.HandleDateChange('startDate', date)
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>

                  <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">To</label>
                    <DatePicker
                      selected={this.state.endDate}
                      onChange={(date) => {
                        this.HandleDateChange('endDate', date)
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={this.state.startDate}
                    />
                  </div>

                  <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <button
                      onClick={() => {
                        this.PopulateTable()
                      }}
                      style={{ position: 'relative', marginTop: 36 }}
                      id="FormSearchBtn"
                      className="btn SearchTable_Btn"
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      onClick={() => window.open('/Map')}
                      className="ml-3 btn SearchTable_Btn"
                    >
                      View Map
                    </button>
                  </div>
                </div>

                <Table
                  keyField="id"
                  data={this.state.data}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  onTableChange={this.handleTableChange}
                  isPagination={true}
                  columns={columns}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 100)
                  }}
                  loading={this.state.loading}
                  exportPdf={this.ExportPdf}
                  exportAllowed={true}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }
  componentDidMount() {
    Common.AddClassToMenueLink(
      'MenuParentLink_HeatMap',
      false,
      'MenuParentLink_Security',
    )

    this.GetPageConfigData(() => {
      this.PopulateTable()
    })
  }

  GetPageConfigData = (CallBack) => {
    this.props.ShowLoader({ Isloading: true })

    var d2 = $.Deferred()

    this.SelectDistricts(() => {
      d2.resolve()
    })

    $.when(d2).done(() => {
      this.props.ShowLoader({ Isloading: false })
      CallBack()
    })
  }
  handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    if (type === 'sort') {
      let result = this.state.data
      // Handle column sort
      if (sortOrder === 'asc') {
        result = result.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1
          } else if (b[sortField] > a[sortField]) {
            return -1
          }
          return 0
        })
      } else {
        result = result.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1
          } else if (b[sortField] > a[sortField]) {
            return 1
          }
          return 0
        })
      }
      return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }

  SelectDistricts = (Callback) => {
    this.setState({ DistrictLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {},
      (data) => {
        this.setState({
          DistrictLoader: false,
          Districtlist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ DistrictLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }

  ExportPdf = () => {
    const doc = new jsPDF()

    var districtIdString =
      this.state.DistrictId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','

    var Parameters = {
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
      districtIdString,
    }

    this.setState({ loading: true })

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'POST',
      false,
      Common.BaseUrlAPI + '/api/Dashboard/HeatMap',
      JSON.stringify(Parameters),
      (resp) => {
        this.setState({ loading: false })
        if (resp.status) {
          doc.autoTable({
            theme: 'grid',
            body: [...resp.data],
            columns: [
              { header: 'id', dataKey: 'id' },
              { header: 'Name', dataKey: 'name' },
              { header: 'Samples Created', dataKey: 'samplesCreated' },
              {
                header: 'Completed Assignments',
                dataKey: 'completedAssignments',
              },
              { header: 'Samples Transported', dataKey: 'samplesTransported' },
            ],
          })

          doc.save('name.pdf')
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  ExportData = (size) => {
    this.setState({ loading: true })
    var districtIdString =
      this.state.DistrictId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','

    var Parameters = {
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
      districtIdString,
    }

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'POST',
      false,
      Common.BaseUrlAPI + '/api/Dashboard/HeatMap',
      JSON.stringify(Parameters),
      (resp) => {
        this.setState({ loading: false })
        if (resp.status) {
          this.setState({
            data: resp.data,
            TotalRecord: resp.totalRecord,
            exportLoading: false,
          })
          $('.react-bs-table-csv-btn').click()
          this.PopulateTable()
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  PopulateTable = () => {
    this.setState({ loading: true })

    var districtIdString =
      this.state.DistrictId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','

    var Parameters = {
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
      districtIdString,
    }

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'POST',
      false,
      Common.BaseUrlAPI + '/api/Dashboard/HeatMap',
      JSON.stringify(Parameters),
      (resp) => {
        this.setState({ loading: false })
        if (resp.status) {
          this.setState({
            data: resp.data,
            TotalRecord: resp.data.length,
          })
          this.props.MapReducer(this.state.data)
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  onDelete = (id) => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Dispute?',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = (id) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.BaseUrlAPI + '/api/Dispute/Delete',
      {
        id: id,
      },
      (Result) => {
        if (Result.status) {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully' })
          this.PopulateTable()
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
          $('#Form_CancelBtn').click()
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeatMap_List)
